<template>
    <v-navigation-drawer
      v-model="$store.state.drawer"
      absolute
      dark
      id="va-drawer"
      color="zera-nav"
      :mini-variant.sync="mini"
      expand-on-hover
    >
  
    <v-list-item class="px-2">
        <v-list-item-avatar>
          <v-img :src="$store.state.applogo" ></v-img>
        </v-list-item-avatar>

        <v-list-item-title>{{isFranchisee}}</v-list-item-title>

        <v-btn
          icon
          @click.stop="mini = !mini"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-list-item>
    
      <v-divider></v-divider>
      <v-list dense>
      <v-list-item-group color="fff">
          <v-list-item @click="$router.push('dashboard').catch(err => {})">
          <v-list-item-icon>
            <v-icon >mdi-view-dashboard</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title >Dashboard</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
       <v-divider></v-divider>
      
         <v-subheader class="mid-font"><span v-if="!mini">INVENTORY</span></v-subheader>

           <v-list-item
                v-for="(item, index) in $store.state.invetory_menus"
                :key="index"
                
                  @click="$router.push(item.page).catch(err => {})"
              >
                  <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
                <v-list-item-content >
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
 <v-subheader class="mid-font"><span v-if="!mini">ACCOUNTS</span></v-subheader>
          <v-list-item
                v-for="(item, index) in $store.state.account_menus"
                :key="index + '-ac'"
                
                  @click="$router.push(item.page).catch(err => {})"
              >
                  <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
                <v-list-item-content >
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-subheader class="mid-font" ><span v-if="!mini">REPORTS</span></v-subheader>
            <v-list-item
                v-for="(item, index) in $store.state.report_menus"
                :key="index + '-rd'"
                
                  @click="$router.push(item.page).catch(err => {})"
              >
                  <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
                <v-list-item-content >
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
          </v-list-item>
           <v-divider></v-divider>
   <v-subheader class="mid-font"><span v-if="!mini">Staff</span></v-subheader>
            <v-list-item
                v-for="(item, index) in $store.state.staff_menus"
                :key="index + '-sd'"
                
                  @click="$router.push(item.page).catch(err => {})"
              >
                  <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
                <v-list-item-content >
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>

 <v-subheader class="mid-font"><span v-if="!mini">ADMINISTRATOR</span></v-subheader>
            <v-list-item
                v-for="(item, index) in $store.state.admin_menus"
                :key="index + '-ad'"
                
                  @click="$router.push(item.page).catch(err => {})"
              >
                  <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
                <v-list-item-content >
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>

       </v-list-item-group>
       
      </v-list>
  
    </v-navigation-drawer>

</template>
<script>
import {
  mapMutations
} from 'vuex'
  export default {
    data () {
      return {
        item: 1,
        mini: true,
        items: ["Test 1", "Test 2", "Test 3", "Test 4", "Test 5"]
      }
    },
    created(){
      console.log(this.operation_menu)
    },
    computed: {
      isFranchisee(){
       if(this.$session.get('role') == "Franchisee") {
              return this.$store.state.franchise.company
       } else {
           return "Zera"
       }
    },
      operation_menu() {
        if(this.$session.get('role') == "Administrator") {
          return this.$store.state.operation_menus
        }
        var account = this.$session.get("account")
        console.log(account.page_permissions)
        var menus = account.page_permissions.reduce((res, item)=>{
         
            for(var i=0; i<this.$store.state.invetory_menus.length;i++) {
              if(this.$store.state.invetory_menus[i].title.trim() == item.trim()) {
                res.push(this.$store.state.invetory_menus[i])
              }
            }
            return res
        }, [])
        return menus
      },
       admin_menu() {
        if(this.$session.get('role') == "Administrator") {
          return this.$store.state.admin_menus
        }
        var account = this.$session.get("account")
        var menus = account.page_permissions.reduce((res, item)=>{
         
            for(var i=0; i<this.$store.state.admin_menus.length;i++) {
              if(this.$store.state.admin_menus[i].title.trim() == item.trim()) {
                res.push(this.$store.state.admin_menus[i])
              }
            }
            return res
        }, [])
        return menus
      },
       report_menu() {
        if(this.$session.get('role') == "Administrator") {
          return this.$store.state.report_menus
        }
        var account = this.$session.get("account")
        var menus = account.page_permissions.reduce((res, item)=>{
         
            for(var i=0; i<this.$store.state.report_menus.length;i++) {
              if(this.$store.state.report_menus[i].title.trim() == item.trim()) {
                res.push(this.$store.state.report_menus[i])
              }
            }
            return res
        }, [])
        return menus
      },
       partner_menu() {
        if(this.$session.get('role') == "Administrator") {
          return this.$store.state.partner_menus
        }
        var account = this.$session.get("account")
        var menus = account.page_permissions.reduce((res, item)=>{
         
            for(var i=0; i<this.$store.state.partner_menus.length;i++) {
              if(this.$store.state.partner_menus[i].title.trim() == item.trim()) {
                res.push(this.$store.state.partner_menus[i])
              }
            }
            return res
        }, [])
        return menus
      },
      account_menus() {
        return this.$store.state.account_menus
      },
      finance_menus() {
        return this.$store.state.finance
      },
      service_menus() {
        return this.$store.state.service
      },
      organization_menus() {
        return this.$store.state.organization
      }
    },
    methods: {
      ...mapMutations(['setDrawer']),
    }
  }
</script>